<template>
    <div>
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder  text-dark"
               :class="item.is_required ? 'required' : ''"
        >
            <slot v-if="i18n.locale.value == 'ar'">
                {{item.label_ar}}
            </slot>
            <slot v-if="i18n.locale.value == 'en'">
                {{item.label}}
            </slot>
            <slot v-if="!item.is_required">&nbsp;{{$t('optional')}}</slot>
        </label>
        <!--end::Label-->

        <template v-if="item.type == 'Radio'">
            <div class="row">
                <div v-for="(selection,key) in item.selection_values" class="col-md-4">
                    <label class='d-flex flex-stacks  mb-5 cursor-pointer'>
                        <span class='form-check form-check-custom form-check-solid'>
                                                <Field
                                                        v-model="item.value"
                                                        class='form-check-input'
                                                        type='radio'
                                                        :rules="$helpers.getValidationRules(item)"
                                                        :name=" item.model_key + item.key"
                                                        :value="selection.id"
                                                        :class="selection.id == item.value ? 'checked' : ''"
                                                        :checked="selection.id == item.value"
                                                        :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                                                        @change="triggerChange(selection.id)"
                                                />
                                              </span>
                        <span class='d-flex align-items-center me-2'>
                                        <span class='d-flex flex-column '>
                                          <span class='fw-bolder  fs-5'
                                                :class="selection.id == item.value ? 'text-danger text-decoration-underline': 'text-gray-800'">{{i18n.locale.value == 'ar' ? selection.value_ar : selection.value}}</span>
                                        </span>
                                </span>
<!--{{item.value}}-->
                    </label>
                </div>
            </div>
        </template>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<span class="text-dark">({{item.type}})</span>-->
                <slot v-if="i18n.locale.value == 'ar'">
                    <span class="text-muted">{{item.hint_text_ar}}</span>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                    <span class="text-muted">{{item.hint_text_en}}</span>
                </slot>
            </div>
        </div>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<ErrorMessage :name="item.model_key + item.key"/>-->
                <ErrorMessage :name="item.model_key + item.key" v-slot="{ message }">
                    <template v-if="item.validation_error_msg_ar  && i18n.locale.value == 'ar'">
                        <slot>
                            {{item.validation_error_msg_ar}}
                        </slot>
                    </template>
                    <template v-if="item.validation_error_msg  && i18n.locale.value == 'en'">
                        <slot>
                            {{item.validation_error_msg}}
                        </slot>
                    </template>
                    <template
                            v-if="!(item.validation_error_msg_ar  && i18n.locale.value == 'ar')  && !(item.validation_error_msg  && i18n.locale.value == 'en')">
                        <slot>
                            {{message}}
                        </slot>
                    </template>
                </ErrorMessage>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
  import {
    defineComponent,
    ref,
    reactive,
    toRefs,
    inject,
    defineAsyncComponent,
    onMounted,
    nextTick,
  } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import * as _ from 'lodash';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormRadioInput',
    components: {
      Field,
      ErrorMessage,
      FormBuilder: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormBuilder.vue'),
      ),
    },
    props: ['item', 'items', 'iterator'],
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      const state = reactive({
        item: props.item,
        items: props.items,
        iterator: props.iterator,
      });

      onMounted(() => {
        if (state.item) state.item.value = (state.item.value) ? (state.item.value).toString() : null;
      });

      const triggerChange = (selection) => {
        let item: any = state.item;
        let iterator: any = state.iterator;
        let selected_value: any = JSON.parse(JSON.stringify((getSelectValue(item, selection))));


        // remove item
        let removalKeys: any = [];
        _.forEach(item.selection_values, (SV) => {
          let SECTION: any = SV?.section;
          // if (SECTION && SV.id != selected_value.id) {
            removalKeys.push(SECTION?.model_key);
          // }
        });
        _.remove(state.items, function(currentObject: any) {
          return removalKeys.includes(currentObject.model_key);
        });

        if (selected_value && selected_value.section) {
          setTimeout(()=>{
            state.items.splice(iterator + 1 , 0, cloneSection(selected_value.section));
          },100)
        }
        // if (selected_value.section) {
        //   let insertItem = insertAfterIndex(state.items, iterator, cloneSection(selected_value.section));
        //
        //   state.items.splice(0);
        //   _.forEach(insertItem, (item) => {
        //     state.items.push(item);
        //   });
        // }
      };

      const insertAfterIndex = (arr, index, newItem) => [
        ...arr.slice(0, index + 1),

        newItem,

        ...arr.slice(index + 1),
      ];

      const cloneSection = (section) => {
        let clonedSectionItem: any = Object.assign({}, section);
        clonedSectionItem.key = `_main_${Math.random().toString(16)}`;
        clonedSectionItem.section_repeat_index = 1;

        let itemsR: any = [];
        _.forEach(clonedSectionItem.items, (oldItem) => {
          // oldItem = JSON.parse(JSON.stringify(oldItem));
          oldItem.key = `_sub_${Math.random().toString(16)}`;
          oldItem.value = null;
          oldItem.values = [];
          if(oldItem.type != "Section") itemsR.push(oldItem);
        });
        return clonedSectionItem;
      };

      const getSelectValue = (item, val) => {
        let Gitem: any = null;
        _.forEach(item.selection_values, (_item) => {
          if (_item.id == val) {
            Gitem = _item;
            return;
          }
        });
        return Gitem;
      };

      return {
        ...toRefs(state),
        i18n,
        triggerChange,
        helpers,
        getSelectValue,
      };
    },
  });
</script>
<style>
    .form-check.form-check-solid .form-check-input:checked {
        background-color: #E50019 !important;
    }

    .form-check.form-check-solid .form-check-input.checked {

        background-color: #E50019 !important;
    }
</style>
